<template>
  <div class="content">
    <div class="content_title">
      Интеграции
    </div>
    <div>
      <button @click="showAddIntegration=true">Добавить интеграцию</button>
    </div>
    <div class="content_row" v-show="showAddIntegration">
      <div>
        <label>Название: <input v-model="type_name"/></label>
      </div>
      <div>
        <label>Адрес: <input v-model="server_ip"/></label>
      </div>
      <div>
        <label>Логин: <input v-model="login"/></label>
      </div>
      <div>
        <label>Пароль: <input v-model="password"/></label>
      </div>
      <div>
        <label>Тип идентификации:
          <select  v-model="identification" multiple="multiple">
            <option selected value="">-</option>
            <option value="RFID">RFID</option>
            <option value="QR">QR</option>
            <option value="Гос. знаки">Гос. знаки</option>
          </select>
        </label>
      </div>
      <div>
        <button @click="addParsecAccount">Подключить</button>
      </div>
    </div>
    <div
      class="content_row"
      v-for="(parsecAccount, key) in parsecAccounts"
      :key="key"
    >
      <div>
        {{ parsecAccount.NAME }}
      </div>
      <div>
        {{ parsecAccount.SERVER_IP }}
      </div>
      <div>
        {{ parsecAccount.LOGIN }}
      </div>
      <div>
        {{ parsecAccount.LAST_USED?'Подключена':'Не подключен' }}
      </div>
      <div>
        <button @click="updateParsecData(parsecAccount.ID)">
          Обновить
        </button>
      </div>
      <div>
        <button @click="deleteParsecAccount(parsecAccount.ID)">
          Удалить аккаунт
        </button>
      </div>
    </div>

    <div class="content_title">
      КПП
    </div>
    <div>
      <button @click="addKppButton">Добавить КПП</button>
    </div>
    <div v-show="showAddKpp">
      <div class="content_row">
        <div>
          <label>Название: <input v-model="kppName"/></label>
        </div>
        <div>
          <select id="name-input" v-model="kppIdVillages" multiple="multiple">
            <option
              v-for="(village, key) in villages"
              :value="village.ID"
              :key="key"
            >
              {{ village.NAME }}
            </option>
          </select>
        </div>
        <div>
          <label>Интеграция:
            <select  v-model="kppIntegration">
              <option selected value="">-</option>
              <option
                v-for="(parsecAccount, key) in parsecAccounts"
                :value="parsecAccount.ID"
                :key="key"
              >
                {{ parsecAccount.NAME }}
              </option>
            </select>
          </label>
        </div>
        <div>
          <button @click="addKpp">Сохранить</button>
        </div>
      </div>
      <div><button @click="kppTypes.push({METHOD: 'manual'})">Добавить тип проезжающего</button></div>
      <div
        v-for="(type, key) in kppTypes" class="content_row" v-bind:key = "key">
        <div>
          <label>Название типа проезжающих: <input v-model="type.NAME"/></label>
        </div>
        <div>
          <label>Способ: <select v-model="type.METHOD">
              <option value="manual" selected="selected">Ручной</option>
              <template v-if="kppIntegration">
                <option
                  v-for="(kppIdent, key) in parsecAccounts[kppIntegration].IDENTITY.split(',')"
                  :key="key"
                  :value="kppIdent"
                >
                  {{ kppIdent }}
                </option>
              </template>
            </select>
          </label>
        </div>
        <div>
          <label>Срочность пропусков: <select v-model="type.TIME">
              <option value="Постоянный">Постоянный</option>
              <option value="Временный">Временный</option>
            </select>
          </label>
        </div>
        <div>
          <label for="org-select">Услуга:</label>
          <select id="org-select" v-model="type.SERVICE_ID">
            <option
              v-for="(service, key) in services"
              :key="key"
            :value="service.ID"
          >
            {{ service.NAME }}
          </option>
        </select>
      </div>
        <div>
          <label>Группа доступа: <select v-model="type.PARSEC_GROUP_ID">
            <option
              v-for="(group, key) in parsecgroups"
              :value="group.ID"
              :key="key"
            >
              {{ group.NAME }}
            </option>
          </select>
          </label>
        </div>
      </div>
    </div>
    <div
      class="content_row"
      v-for="(kpp, key) in kpps"
      :key="key"
    >
      <div>
        Название КПП: {{ kpp.NAME }}
      </div>
      <div>
        Поселок: {{ kpp.VILLAGE }}
      </div>
      <div>
        <a v-bind:href="'/#/backoffice/integrations/types-for-kpp/'+ kpp.ID">Количество способов идентификации: {{ kpp.NUMBER_OF_TYPES }}</a>
      </div>
      <div>
        Количество линий проезда: {{ kpp.NUMBER_OF_LINES }}
      </div>
    </div>
    <paint-access-line-int v-show="kpps" ref="lineComp"></paint-access-line-int>
  </div>
</template>

<script>
import config from "@/config";
import PaintAccessLineInt from "./PaintAccessLineInt";

export default {
  name: "GetIntegrationAccounts",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PaintAccessLineInt
  },
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      parsecAccounts: [],
      showLink: true,
      showAddIntegration: false,
      showAddKpp: false,
      login: "",
      password: "",
      server_ip: "",
      type_name: "Парсек",
      villages: [],
      kppName: '',
      kppIdVillages: [],
      kppTypes: [],
      services: [],
      parsecgroups: [],
      kpps: [],
      kppIntegration: '',
      identification: []
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getParsecAccounts();
      }
    }
  },
  methods: {
    getParsecAccounts: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecaccounts/get/",
          filter: { AGREEMENT: user.id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecAccounts = data;
          }
        });
    },
    addParsecAccount: function() {
      let self = this;
      let user = this.$store.getters["user/getProfile"];
      this.showAddIntegration = false;
      let newAccount = {
        NAME: self.type_name,
        LOGIN: self.login,
        PASSWORD: self.password,
        SERVER_IP: self.server_ip,
        AGREEMENT: user.id,
        IDENTITY: self.identification
      };
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecaccounts/add/",
          data: newAccount,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.getParsecAccounts();
          alert(data.message);
          if(data.success){
            self.updateParsecData(data.parsecaccounts);
          }
        });
    },
    updateParsecData: function (accountId){
      let self = this;
      self.$store
        .dispatch("query/sendRequest", {
          url: self.url + "cron/load-data-from-parsec/",
          data: {ACCOUNT_ID: accountId},
          method: "POST"
        })
        .then(function() {
          self.getParsecAccounts();
        });
    },
    deleteParsecAccount: function(account_id) {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecaccounts/delete/",
          data: { ID: account_id },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          self.getParsecAccounts();
        });
    },
    updateTypes: function() {
      this.$refs.types_link.getGroupsData();
    },
    getVillages: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "villages/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
          }
        });
    },
    getKpps: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "kpp/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.kpps = data;
          }
        });
    },
    addKpp: function (){
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "kpp/add/",
          data: {
            kppName: self.kppName,
            kppIdVillages: self.kppIdVillages,
            kppTypes: self.kppTypes,
            kppIntegration: self.kppIntegration,
            kppIdentification: self.kppIdentification
          },
          method: "POST"
        }).then(function(response) {
        let data = response.data;
        self.showAddKpp = false;
        self.getKpps();
        self.$refs.lineComp.getKpps();
      });
    },
    addKppButton: function (){
      this.showAddKpp = true;
    },
    getServices: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    },
    getAccessGroups: function (){

      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecgroups = data;
          }
        });
    }
  },
  created() {
    this.getParsecAccounts();
    this.getVillages();
    this.getKpps();
    this.getAccessGroups();
    this.getServices();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
